<!--Navbar-->
<mdb-navbar
  SideClass="navbar navbar-expand-lg navbar-dark indigo "
  [containerInside]="false"
>
  <!-- Navbar brand -->
  <mdb-navbar-brand
    ><a class="navbar-brand" [routerLink]="['/']">Maktabti</a></mdb-navbar-brand
  >

  <!-- Collapsible content -->
  <links>
    <!-- Links -->
    <ul class="navbar-nav ml-auto text-uppercase ">
      <li
        class="nav-item"
        [routerLink]="['/']"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a routerLink="/" class="nav-link waves-light" mdbWavesEffect
          ><mdb-icon fas icon="book"></mdb-icon> all Books
        </a>
      </li>

      <li class="nav-item " routerLinkActive="active">
        <a
          class="nav-link waves-light"
          [routerLink]="['/favoriteBooks']"
          routerLinkActive="active"
          mdbWavesEffect
          ><mdb-icon fas icon="rss"></mdb-icon> Top Rated books</a
        >
      </li>
      <li class="nav-item " routerLinkActive="active">
        <a
          class="nav-link waves-light"
          [routerLink]="['/news']"
          routerLinkActive="active"
          mdbWavesEffect
          ><mdb-icon fas icon="fire "></mdb-icon>Books news</a
        >
      </li>
      <li class="nav-item " routerLinkActive="active">
        <a
          class="nav-link waves-light"
          [routerLink]="['/admin']"
          routerLinkActive="active"
          mdbWavesEffect
          *ngIf="isAdmin"
          ><mdb-icon fas icon="sign-in-alt"></mdb-icon> Dashboard</a
        >
      </li>
      <li class="nav-item " routerLinkActive="active">
        <a
          class="nav-link waves-light"
          [routerLink]="['/login']"
          routerLinkActive="active"
          mdbWavesEffect
          *ngIf="!isAuth"
          ><mdb-icon fas icon="sign-in-alt"></mdb-icon> login</a
        >
      </li>
      <li class="nav-item " routerLinkActive="active">
        <a
          *ngIf="!isAuth"
          class="nav-link waves-light"
          [routerLink]="['/register']"
          mdbWavesEffect
          ><mdb-icon fas icon="user-plus"></mdb-icon> register</a
        >
      </li>

      <!-- Dropdown -->
      <li class="nav-item dropdown" dropdown>
        <a
          dropdownToggle
          mdbWavesEffect
          type="button"
          class="nav-link dropdown-toggle waves-light"
          mdbWavesEffect
          *ngIf="isAuth"
        >
          <mdb-icon fas icon="user"></mdb-icon> Profile<span
            class="caret"
          ></span
        ></a>
        <div
          *dropdownMenu
          class="dropdown-menu dropdown-menu-right dropdown dropdown-primary"
          role="menu"
        >
          <a
            routerActiveLink="active"
            [routerLink]="['/myBooks']"
            routerLinkActive="active"
            class="dropdown-item waves-light"
            mdbWavesEffect
            *ngIf="isAuth"
            >My Books</a
          >
          <a
            routerActiveLink="active"
            [routerLink]="['/user']"
            routerLinkActive="active"
            class="dropdown-item waves-light"
            mdbWavesEffect
            *ngIf="isAuth"
            >My profile</a
          >

          <a
            routerActiveLink="active"
            routerLink=""
            *ngIf="isAuth"
            class="dropdown-item waves-light"
            mdbWavesEffect
            (click)="logOut()"
            >Log out</a
          >
        </div>
      </li>
    </ul>
  </links>
  <!-- Collapsible content -->
</mdb-navbar>
<!--/.Navbar-->
